import { render, staticRenderFns } from "./PresellOrder.vue?vue&type=template&id=f1208c02&scoped=true"
import script from "./PresellOrder.vue?vue&type=script&lang=js"
export * from "./PresellOrder.vue?vue&type=script&lang=js"
import style0 from "./PresellOrder.vue?vue&type=style&index=0&id=f1208c02&prod&scoped=true&lang=scss"
import style1 from "./PresellOrder.vue?vue&type=style&index=1&id=f1208c02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1208c02",
  null
  
)

export default component.exports